import home from '@/api/home'
import team from '@/api/team'
import setTemp from '@/api/setTemplate'
import util from '@/util/util';
import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
export default new Vuex.Store({
    state:{
        teamModel:1,
        nav_index:0,
        activeMenu:'',
        vnavShow:true,
        routeFrom: localStorage.getItem("routeFrom") || '',
        printedNum:0,
        waitNum: 0,
        orderNum:0,
        rightNum:0,
        wrongNum:0,
        seetIndex:0,
        commondict:localStorage.getItem("commondict") || '',
        connetStatus:{
           WebSocketstatus:'',
           name:'',
           lodopStatus:''
        },
        orderStatus:{
            status:0,
            start:'',
            end:'',
        }, 
        bannerlist:[],
        userSet:localStorage.getItem("userSet") || '{}',
        editbill:localStorage.getItem("editbill") || '{}',   
        listrefresh:new Date().getTime(),
        bindKdy:'',
        mgcColorRow:[],
        mailnum:0,
        // ydRealname:localStorage.getItem("ydRealname") || false,
    },
    mutations:{
        SET_BIND_KDY(state,bindKdy){
            state.bindKdy = bindKdy
        },
        SET_TEAM_MODEL(state,val){
            state.teamModel = val
        },
        SET_NAV_INDEX(state,nav_index){
            state.nav_index = nav_index
        },
        SET_LIST_REFRESH(state,listrefresh){
            state.listrefresh = listrefresh     
        },
        SET_EDIT_BILL(state,editbill){
            localStorage.setItem("editbill", editbill);
            state.editbill = editbill
        },
        // SET_YD_REALNAME(state,ydRealname){
        //     localStorage.setItem("ydRealname", ydRealname);
        //     state.ydRealname = ydRealname
        // },
        SET_BANNER_LIST(state,bannerlist){
            state.bannerlist = bannerlist;
        },
        SET_ACTIVE_MENU(state,activeMenu){
            debugger
            state.activeMenu = activeMenu;
        },
        SET_USER_SET(state,userSet){
            localStorage.setItem("userSet", userSet);
            state.userSet = userSet;
        },
        SET_ORDER_STATUS(state,orderStatus){
            state.orderStatus = orderStatus;
        },
        SET_COMMON_DICT(state,commondict){
            localStorage.setItem("commondict", commondict);
            state.commondict = commondict;
        },
        SET_SHEET_INDEX(state,seetIndex){
            state.state = seetIndex
        },
        SET_SHEET_TYPE(state,sheetNum){
            state.state = sheetNum
        },
        SET_PRINT_NUM(state,printedNum){
            state.printedNum = printedNum
        },
        SET_WAIT_NUM(state,waitNum){
            state.waitNum = waitNum
        },
        SET_ORDER_NUM(state,orderNum){
            state.orderNum =orderNum
        },
        SET_VNAV_show(state,vnavShow){
            state.vnavShow 
        },
        SET_ROUTE_FROM(state, routeFrom) {
            localStorage.setItem("routeFrom", routeFrom);
            state.routeFrom = routeFrom;
        },
        SET_MAIL_NUM(state,mailnum){
            state.mailnum =mailnum
        },
    },
    getters:{
        getFrom: state => {
            return state.routeFrom;
        },
        getListrefresh: state => {
            return state.listrefresh;
        },
        getTeammodel: state => {
            return state.teamModel;
        },
    },
    actions: {
        getthreeNum({ commit, state }) {
            let query = {
                print_type:1,
                start_time:util.getlimiTime(30) + ' 00:00:00',
                end_time:util.getlimiTime(0)+' 23:59:59',
                order_status:0
            }
            home.getthreeNum(query).then((res) => {
                commit('SET_PRINT_NUM', res.data.yes_print_num)
                // commit('SET_ORDER_NUM', res.data.mail_order_num)
            })
            home.getBillNum(null,query).then(res=>{
                commit('SET_WAIT_NUM', res.data)
            })
        },
        // 查询用户当前模式1个人_2团队
        getRole({ commit, state }){
            team.getTeamModel(this).then((res) => {
                if (res.success){
                    let result = res.data.data
                    util.setCookie("teamModel", result);
                    commit('SET_TEAM_MODEL', result)
                }
            })
        },
        // 查询用户打印机名称
        getprintName({ commit, state }){
            setTemp.getgetPrintName(this).then(res=>{
                if(res.success){
                    let name = res.data
                    util.setCookie("defult_print",name); 
                    console.log('当前预设打印机名称:'+ name)
                }
            })  
        },
        // 查询绑定关系
        getBindType({commit, state}){
            home.hasbind(this).then((res) => {
                if (res.success){
                   commit('SET_BIND_KDY', res.data)
                }
            })
        }
    }
})